<template>
  <div class="modelList_box" style="margin-top: 0">
    <div class="tools app_container" :style="iszero?'background: #fff; margin-top:20px;margin-bottom:5rem;':'background: #fff; margin-top:20px'">
      <div class="container px-4 py-5" id="custom-cards" style="max-width:100%">
        <h2 class="pb-2 border-bottom">软件/工具</h2>
        <div class="row row-cols-1 row-cols-md-1 row-cols-lg-4 align-items-stretch g-4 py-5">
          <div class="col" v-for = "(item,index) in allToolList" :key = "item.storename||item.name" v-if = "item.type == 1" v-on:click="(item.storename||item.name)!='森视频'?checkCampany(item):''">
            <div :class="'card card-cover h-100 overflow-hidden text-white rounded-5 shadow-l bg_'+(index+1)" :style="'background-color: transparent !important;background-image: url('+(item.storeicon||item.icon)+');'+((item.storename||item.name)=='森视频'?'cursor:default;':'')+''" >
              <div class="d-flex flex-column h-100 p-5 pb-3 text-shadow-1">
                <h2 class="pt-5 mt-5 mb-4 display-6 lh-1 fw-bold">{{ item.storename||item.name }}
                    <span style = "font-size: 18px">{{ item.storetitleName||item.titleName }}</span>
                <br>
                    <span v-if="item.storenamecn" style="font-weight: 500">{{ item.storenamecn||item.namecn }}</span>
                </h2>
                <div v-if=" (item.storechildren||item.children)&&((item.storechildren&&item.storechildren.length) || item.children.length)" style="margin-top: -2.0rem; line-height: 20px; font-size: 0.8rem;width: 45%;" class="item-children">
                    <span v-if="child.name!='森园区'" v-for="(child,i) in (item.storechildren||item.children)" v-on:click="checkCampany(child,$event)" style="cursor: pointer;" :key = i>
                        <label style="margin-bottom:0;margin:0 5px;color:#a7a0a0" v-if="i>0">|</label>
                        {{child.name.replace('森视频','').replace('离线开发网络版更新包','').replace('离线开发坐席版更新包','').replace('项目离线部署更新包','').replace('ThingJS-X离线开发更新包','').replace('离线开发web版更新包','')}}
                    </span>
                    <span  v-if="child.name=='森园区'" v-for="(child,i) in (item.storechildren||item.children)" v-on:click="checkCampany(child,$event)" style="cursor: pointer;" :key = i>
                        <label style="margin-bottom:0;margin:0 5px;color:#a7a0a0" v-if="i>0">|</label>
                        Windows
                    </span>
                </div>
              </div>
              <!-- <div class="subtitle1" style="position: relative">
              </div> -->
              <div class="subtitle" style="color:#747474;font-size: 0.8rem;">
                    <span>{{ item.storesubtitle||item.subtitle }}</span>
              </div>
              <ul class="d-flex list-unstyled mt-auto" style="justify-content: flex-end;" :class="((item.storename||item.name) != '视频流服务器'?'d-flex list-unstyled mt-auto':'d-flex list-unstyled mt-auto splCard')" >
                  <!-- <li class="me-auto">
                    <img src="../../static/img/favicon1.png" alt="Bootstrap" width="25"  height="25" style="cursor: default;" class="rounded-circle" />
                  </li> -->
                  <!-- <li class="d-flex align-items-center me-13" >
                    <div :style="'background-image: url('+item.eachicon2+');'" class="firstRow"></div>
                    <small style="color: black;" :style="(index==3?'cursor:default;':'cursor: pointer;')">{{ item.samllname }}</small>
                  </li> -->
                  <li class="d-flex align-items-center me-3 newButton" v-if="((item.storename||item.name) != '视频流服务器')&&((item.storename||item.name) != '离线开发坐席版')" :class="(((item.storename||item.name) != '森园区') && ((item.storename||item.name) != '森Max') && ((item.storename||item.name) != '森BIM')?'d-flex align-items-center me-3 newButton rightStyleNew':'d-flex align-items-center me-3 newButton rightStyle')">
                    <div :style="'background-image: url('+item.eachicon+');'" class="firstRow"  style="width:14px;height:14px;"></div>
                    <small style="color: #fff;font-size: 0.8rem; " :style="(index==3?'cursor:default;':'cursor: pointer;')">{{ item.storesamllname||item.samllname }}</small>
                  </li>
                  <li class="d-flex align-items-center newButton" v-if="((item.storename||item.name) != '视频流服务器') && ((item.storename||item.name) != '森园区') && ((item.storename||item.name) != '森Max') && ((item.storename||item.name) != '森BIM')">
                    <img v-if="(item.storename||item.name) != '离线开发网络版' &&(item.storename||item.name) != '离线开发Web版' &&(item.storename||item.name) != '离线开发坐席版' && (item.storename||item.name) != '项目离线部署' && (item.storename||item.name) != 'ThingJS-X离线开发'" src="../../static/img/3dlogo.png" alt="" style="width:1.3rem;height:1.3rem;" :style="(index==3?'cursor:default;':'cursor: pointer;')">
                    <small v-if="(item.storename||item.name) != '离线开发网络版' &&(item.storename||item.name) != '离线开发Web版' && (item.storename||item.name) != '离线开发坐席版' && (item.storename||item.name) != '项目离线部署' && (item.storename||item.name) != 'ThingJS-X离线开发'" style="color: #fff;font-size: 0.8rem;margin-left: 0.4rem;" :style="(index==3?'cursor:default;':'cursor: pointer;')">3d</small>

                    <img v-if="(item.storename||item.name) == '离线开发网络版' ||(item.storename||item.name) == '离线开发Web版' || (item.storename||item.name) == '项目离线部署' || (item.storename||item.name) == 'ThingJS-X离线开发'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[0])||item.children[0]),$event)" :src="item.storeeachicon2||item.eachicon2" alt="" style="width:14px;height:14px;" :style="(index==3?'cursor:default;':'cursor: pointer;')">
                    <small v-if="(item.storename||item.name) == '离线开发网络版'||(item.storename||item.name) == '离线开发Web版' || (item.storename||item.name) == '项目离线部署' || (item.storename||item.name) == 'ThingJS-X离线开发'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[0])||item.children[0]),$event)" style="color: #fff;font-size: 0.8rem;margin-left: 0.4rem;" :style="(index==3?'cursor:default;':'cursor: pointer;')">下载</small>
                    <img v-if="(item.storename||item.name) == '离线开发坐席版'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[0])||item.children[0]),$event)" :src="item.storeeachicon2||item.eachicon2" alt="" style="width:14px;height:14px;" :style="(index==3?'cursor:default;':'cursor: pointer;')">
                    <small v-if="(item.storename||item.name) == '离线开发坐席版'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[0])||item.children[0]),$event)" style="color: #fff;font-size: 0.8rem;margin-left: 0.4rem;" :style="(index==3?'cursor:default;':'cursor: pointer;')">下载</small>
                  </li>
                  <li class="d-flex align-items-center newButton moreText" v-if="(item.storename||item.name) == '视频流服务器'">
                    <img v-if="(item.storename||item.name) == '视频流服务器'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[1])||item.children[1]),$event)" :src="item.storeeachicon||item.eachicon" alt="" style="width:14px;height:14px;" :style="(index==3?'cursor:default;':'cursor: pointer;')">
                    <small v-if="(item.storename||item.name) == '视频流服务器'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[1])||item.children[1]),$event)" style="color: #fff;font-size: 0.8rem;margin-left: 0.4rem;" :style="(index==3?'cursor:default;':'cursor: pointer;')">{{isNormal?'GB下载':'GB'}}</small>
                  </li>
                  <li class="d-flex align-items-center newButton moreText" v-if="(item.storename||item.name) == '视频流服务器'">
                    <img v-if="(item.storename||item.name) == '视频流服务器'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[0])||item.children[0]),$event)" :src="item.storeeachicon2||item.eachicon2" alt="" style="width:14px;height:14px;" :style="(index==3?'cursor:default;':'cursor: pointer;')">
                    <small v-if="(item.storename||item.name) == '视频流服务器'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[0])||item.children[0]),$event)" style="color: #fff;font-size: 0.8rem;margin-left: 0.4rem;" :style="(index==3?'cursor:default;':'cursor: pointer;')">{{isNormal?'GB下载':'GB'}}</small>
                  </li>
                  <li class="d-flex align-items-center newButton moreText" v-if="(item.storename||item.name) == '视频流服务器'">
                    <img v-if="(item.storename||item.name) == '视频流服务器'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[3])||item.children[3]),$event)" :src="item.storeeachicon3||item.eachicon3" alt="" style="width:14px;height:14px;" :style="(index==3?'cursor:default;':'cursor: pointer;')">
                    <small v-if="(item.storename||item.name) == '视频流服务器'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[3])||item.children[3]),$event)" style="color: #fff;font-size: 0.8rem;margin-left: 0.4rem;" :style="(index==3?'cursor:default;':'cursor: pointer;')">{{isNormal?'RTSP下载':'RTSP'}}</small>
                  </li>
                  <li class="d-flex align-items-center newButton moreText" v-if="(item.storename||item.name) == '视频流服务器'">
                    <img v-if="(item.storename||item.name) == '视频流服务器'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[2])||item.children[2]),$event)" :src="item.storeeachicon4||item.eachicon4" alt="" style="width:14px;height:14px;" :style="(index==3?'cursor:default;':'cursor: pointer;')">
                    <small v-if="(item.storename||item.name) == '视频流服务器'" v-on:click="checkCampany(((item.storechildren&&item.storechildren[2])||item.children[2]),$event)" style="color: #fff;font-size: 0.8rem;margin-left: 0.4rem;" :style="(index==3?'cursor:default;':'cursor: pointer;')">{{isNormal?'RTSP下载':'RTSP'}}</small>
                  </li>
                </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="b-example-divider"></div>
      <div class="container px-4 py-5" id="icon-grid" style="max-width:100%;" v-show="!this.iszero">
        <h2 class="pb-2 border-bottom">文档</h2>
        <div class=" row1 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 x-4 py-5 " >
          <div class="col d-flex align-items-start" v-for = "(item) in allToolList" :key = "(item.storename||item.name)" v-if = "item.type == 2" >
            <div  v-on:click="checkCampany(item)" style="cursor: pointer;box-shadow: 0px 0px 7px 0px #e6e6e6;width: 100%;padding: 0.3rem 1rem;height:100%;">
            <div class="secondRow" style="display: flex;border-bottom: 1px solid #e9e9e9;padding-bottom 0.5rem;">
            <img :src="(item.storeicon||item.icon)" alt="" class="bi text-muted flex-shrink-0 me-3" :title="(item.storename||item.name)"  v-on:click="checkCampany(item)" style="width:2rem;height:2rem;cursor:pointer;margin-right: 0.5rem !important;">
                <h4 class="fw-bold mb-0" style="font-weight: 600 !important;">
                    <div style="display: flex;">
                        {{(item.storename||item.name).replace(' ','')}}
                        <div v-for="(child,i) in (item.storechildren||item.children)" v-on:click="checkCampany(child,$event)" style="font-weight:normal;font-size:15px;margin: 3px 10px;">
                         {{child.name}}
                        </div>
                    </div>
                </h4>
              </div>
              <p>{{(item.storedescr||item.descr)}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="b-example-divider"></div>
      <div class="container px-4 py-5" id="icon-grid" style="max-width:100%;margin-bottom: 3rem;"  v-show="!this.iszero">
        <h2 class="pb-2 border-bottom">其它</h2>
        <div class=" row1 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 x-4 py-5 " >
          <div class="col d-flex align-items-start" v-for = "(item) in allToolList" :key = "item.name" v-if = "item.type == 3" >
            <div  v-on:click="checkCampany(item)" style="cursor: pointer;box-shadow: 0px 0px 7px 0px #e6e6e6;width: 100%;padding: 0.3rem 1rem;height:100%;">
            <div class="secondRow" style="display: flex;border-bottom: 1px solid #e9e9e9;padding-bottom 0.5rem;">
            <img :src="item.icon" alt="" class="bi text-muted flex-shrink-0 me-3" :title="item.name"  v-on:click="checkCampany(item)" style="width:2rem;height:2rem;cursor:pointer;margin-right: 0.5rem !important;">
                <h4 class="fw-bold mb-0" style="font-weight: 600 !important;">
                    <div style="display: flex;">
                        {{item.name.replace(' ','')}}
                        <div v-for="(child,i) in item.children" v-on:click="checkCampany(child,$event)" style="font-weight:normal;font-size:15px;margin: 3px 10px;">
                         {{child.name}}
                        </div>
                    </div>
                </h4>
              </div>
              <p>{{item.descr}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

     <div class="shadowPage" v-show="showToolPage"></div>
      <div class="toolContainer" v-if="showToolPage">
          <div class="pc-title" >
              <span class="pc-head">下载 <span v-if="step">（ {{step}} ）</span></span>
              <span class="layui-layer-setwin"  @click="showToolPage=false;step='';"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
          </div>
          <div class="clearfix" style="padding-top: 22px;padding-right: 16px;">
              <div class="toolLeft">
                  <div class="img_box">
                      <img :src="(toolDetailInfo.storeimgurl||toolDetailInfo.imgurl)" alt="">
                  </div>
                  <div class="downloadBox">
                      <div class="otherdownloadBtn" v-if="toolDetailInfo.otherbtnfont" @click="download(toolDetailInfo.otherdownloadurl)" >
                          {{toolDetailInfo.otherbtnfont}}
                      </div>
                      <div class="downloadBtn" @click="download((toolDetailInfo.storedownloadurl||toolDetailInfo.downloadurl))" >
                          {{toolDetailInfo.btnfont}}
                      </div>
                  </div>
                  <div class="link_box" :class="toolDetailInfo.otherbtnfont?'link_box_other':''">
                      <a v-for="(linkItem) in (toolDetailInfo.storelink||toolDetailInfo.link)" v-if="linkItem.url != 'offlineLog' && linkItem.url != 'offlineSDKLog' && linkItem.url != 'offlineDeploymentLog'&& linkItem.url != 'zeroCodeLog'&& linkItem.url != 'offlineWebLog' " v-bind:key="linkItem.name" :href="linkItem.url" target="_blank">{{linkItem.name}}</a>
                      <a v-for="(linkItem) in (toolDetailInfo.storelink||toolDetailInfo.link)" v-if="linkItem.url == 'offlineSDKLog'" v-on:click="openLog('离线开发坐席版版本更新日志',linkItem.url)" style="color: #007bff">{{linkItem.name}}</a>
                      <a v-for="(linkItem) in (toolDetailInfo.storelink||toolDetailInfo.link)" v-if="linkItem.url == 'offlineLog'" v-on:click="openLog('离线开发网络版版本更新日志',linkItem.url)" style="color: #007bff">{{linkItem.name}}</a>
                      <a v-for="(linkItem) in (toolDetailInfo.storelink||toolDetailInfo.link)" v-if="linkItem.url == 'offlineDeploymentLog'" v-on:click="openLog('项目离线部署版本更新日志',linkItem.url)" style="color: #007bff">{{linkItem.name}}</a>
                      <a v-for="(linkItem) in (toolDetailInfo.storelink||toolDetailInfo.link)" v-if="linkItem.url == 'zeroCodeLog'" v-on:click="openLog('零代码版本更新日志',linkItem.url)" style="color: #007bff">{{linkItem.name}}</a>
                      <a v-for="(linkItem) in (toolDetailInfo.storelink||toolDetailInfo.link)" v-if="linkItem.url == 'offlineWebLog'" v-on:click="openLog('离线开发Web版版本更新日志',linkItem.url)" style="color: #007bff">{{linkItem.name}}</a>
                    </div>
              </div>
              <div class="toolRight">
                  <h3 class="" style="font-size: 16px;font-weight: normal;" v-if="!(toolDetailInfo.storedetailname||toolDetailInfo.detailname)">{{(toolDetailInfo.storename||toolDetailInfo.name)}}</h3>
                  <h3 class="" style="font-size: 16px;font-weight: normal;" v-if="(toolDetailInfo.storedetailname||toolDetailInfo.detailname)">{{(toolDetailInfo.storedetailname||toolDetailInfo.detailname)}}</h3>

                  <ul class="tool_info_ul">
                      <li v-for="(infoItem,index) in (toolDetailInfo.storeinfo||toolDetailInfo.info)" v-bind:key="infoItem.name">
                        <div class="item_left">{{infoItem.name}}:</div>
                        <div class="item_right" style="font-size: 12px; padding-right: 8px; " v-bind:style="index=='4'?'word-break: break-all':''" v-html=infoItem.content></div>
                    </li>
                  </ul>
              </div>
          </div>
      </div>

      <!-- <div id="boxHeader">
          <CamanyInfoService @hidePanel="hidePanel" v-show="panelShow" :panelShow="panelShow"></CamanyInfoService>
      </div> -->
      <!-- <Footer/> -->
  </div>
</template>
<script>
    import bus from '../assets/js/eventBus.js';
    import PurchaseModel from "./PurchaseModel.vue";
    // import Footer from "./Footer.vue";
    import CamanyInfoService from './CampanyInfo.vue';
    // var changeLine = document.createElement('br');
    // changeLine.innerHTML = "</br>";
    export default {
        nanme:"modelList_box",
        components: {
            CamanyInfoService,
            // Footer
        },
        data:function(){
            return{
                queryData:null,
                toolDetailInfo:null,
                showToolPage:false,
                panelShow:false,
                toolList:[],
                step:'',
                newToolList:[],
                iszero:false,
                allToolList:[
                    // 软件/工具
                    {
                        type:1,
                        typename:"软件/工具",
                        name:"森园区",
                        titleName:"(客户端)",
                        samllname:'Campus',
                        namecn: "园区场景搭建",
                        descr:'CampusBuilder 用于园区级 3D 可视化场景搭建。在建筑楼层和室内搭建方面表现卓越。提供大量模型，可直接使用，节省开发时间。',
                        icon:'../../static/img/unsplash-photo-1.png',
                        eachicon:'../../static/img/eachicon1.png',
                        imgurl:"../../static/img/tool/icon_khd.gif",
                        btnfont:"下载",
                        downloadurl:"https://cdn.thingjs.com/tool/CampusBuilder2020x64_cn.zip",
                        link:[
                            {name:"腾讯微云",url:"https://share.weiyun.com/DXMHGfXu"},
                            {name:"使用教程",url:"https://www.thingjs.com/guide/tutorial/"},
                        ],
                        info:[
                             {name:"版本号",content:"1.2.1.273"},
                             {name:"文件大小",content:"1.11GB"},
                             {name:"更新时间",content:"2021/12/02"},

                            {name:"介绍",content:"CampusBuilder 用于园区级 3D 可视化场景搭建。在建筑楼层和室内搭建方面表现卓越。提供大量模型，可直接使用，节省开发时间。"},
                        ],
                        href:"https://www.thingjs.com/guide/tutorial"
                    },
                    {
                        type:1,
                        typename:"软件/工具",
                        name:"森Max",
                        samllname:'3ds',
                        namecn: "模型上传插件",
                        descr:'使用 3ds Max 上传插件可以检测模型是否符合 ThingJS 平台要求，检查模型是否可以正常导入到 CampusBuilder 中使用。另外，还提供模型制作工具，如 ThingJS 工具、模型材质工具、动画制作工具等。',
                        icon:'../../static/img/unsplash-photo-3.png',
                        imgurl:"../../static/img/tool/icon_3d-max.gif",
                        eachicon:'../../static/img/eachicon3.png',
                        btnfont:"下载",
                        downloadurl:"https://cdn.thingjs.com/tool/3DsMax%E4%B8%8A%E4%BC%A0%E6%A8%A1%E5%9E%8B%E6%8F%92%E4%BB%B6V4.4.zip",
                        link:[
                            // {name:"使用教程",url:"http://3dmomoda.oss-cn-beijing.aliyuncs.com/common/%E6%A8%A1%E6%A8%A1%E6%90%AD%E6%8F%92%E4%BB%B6%E4%BD%BF%E7%94%A8%E6%95%99%E7%A8%8B_%E8%AF%A6%E7%BB%862019.12.17.pdf"}
                        ],
                        info:[
                             {name:"版本号",content:"4.4"},
                             {name:"文件大小",content:"96.7MB"},
                             {name:"更新时间",content:"2022/02/22"},

                            {name:"介绍",content:"使用 3ds Max 上传插件可以检测模型是否符合 ThingJS 平台要求，检查模型是否可以正常导入到 CampusBuilder 中使用。另外，还提供模型制作工具，如 ThingJS 工具、模型材质工具、动画制作工具等。"},
                        ]
                    },
                    {
                        type:1,
                        typename:"软件/工具",
                        name:"森BIM",
                        samllname:'森BIM',
                        namecn: "BIM轻量化插件",
                        descr:'森BIM插件能快速获取rvt文件中的模型数据，将rvt 文件转换成 TJS 场景文件格式。简单配置后一键导出TJS场景，无缝对接到ThingJS/ThingJS-X平台。',
                        icon:'../../static/img/unsplash-photo-2.png',
                        detailname:"森BIM",
                        imgurl:"../../static/img/tool/icon_khd.gif",
                        eachicon:'../../static/img/eachicon2.png',
                        btnfont:"下载安装包",
                        downloadurl:"https://www.thingjs.com/guide/?m=sample&citybuilder=true",
                        link:[
                            // {name:"使用教程1",url:"https://www.bilibili.com/video/av74151784/"},
                            // {name:"使用教程2",url:"https://www.bilibili.com/video/av73117194/"},
                            // {name:"使用教程3",url:"https://www.bilibili.com/video/av73116583/"},
                            // {name:"",url:"javascript:void(0);"}
                        ],
                        info:[
                             {name:"版本号",content:"1.0.1.1"},
                             {name:"文件大小",content:"23.4MB"},
                             {name:"更新时间",content:"2022/05/16"},
                            {name:"介绍",content:"可以将 BIM 相关的园区类型 .rvt 文件转换成 ThingJS/ThingJS-X 使用的 TJS 场景文件格式，从而降低建模成本，使场景迅速进入到 ThingJS/ThingJS-X 生态中来。"},
                        ]
                    },
                    {
                        type:1,
                        typename:"软件/工具",
                        name:"森视频",
                        samllname:'Live',
                        children:[
                            {
                                name:'森视频 GB Linux',
                                downloadurl:"https://cdn.thingjs.com/LiveServer/LiveServerGB-20220415-Linux.tar.gz",
                                icon:'../../static/img/unsplash-photo-4.png',
                                imgurl:"../../static/img/tool/icon_3d-max.gif",
                                btnfont:"下载",
                                info:[
                                    {name:"文件大小",content:"31.9MB"},
                                    {name:"更新时间",content:"2022/04/15"},
                                    // {name:"MD5",content:"23662A25B8F6416BF08446DDF92A490E"},
                                    {name:"介绍",content:"森视频提供了GB28181视频流转H5视频流功能，支持海康、大华等各类厂家的标准监控摄像头的接入；单服务器授权，永久有效；提供安装手册及远程技术支持。"},
                                ]
                            },
                            {
                                name:'森视频 GB Win',
                                downloadurl:"https://cdn.thingjs.com/LiveServer/LiveServerGB-20220415-Win.zip",
                                icon:'../../static/img/unsplash-photo-4.png',
                                imgurl:"../../static/img/tool/icon_3d-max.gif",
                                btnfont:"下载",
                                info:[
                                    {name:"文件大小",content:"42.7MB"},
                                    {name:"更新时间",content:"2022/04/15"},
                                    // {name:"MD5",content:"23662A25B8F6416BF08446DDF92A490E"},
                                    {name:"介绍",content:"森视频提供了GB28181视频流转H5视频流功能，支持海康、大华等各类厂家的标准监控摄像头的接入；单服务器授权，永久有效；提供安装手册及远程技术支持。"},
                                ]
                            },
                            {
                                name:'森视频 RTSP Linux',
                                downloadurl:"https://cdn.thingjs.com/LiveServer/LiveServerRTSP-20220415-Linux.tar.gz",
                                icon:'../../static/img/unsplash-photo-4.png',
                                imgurl:"../../static/img/tool/icon_3d-max.gif",
                                btnfont:"下载",
                                info:[
                                    {name:"文件大小",content:"31.0MB"},
                                    {name:"更新时间",content:"2022/04/15"},
                                    // {name:"MD5",content:"23662A25B8F6416BF08446DDF92A490E"},
                                    {name:"介绍",content:"森视频提供了RTSP视频流转H5视频流功能，支持海康、大华等各类厂家监控摄像头的RTSP视频流接入；单服务器授权，永久有效；提供安装手册及远程技术支持。"},
                                 ]
                            },
                            {
                                name:'森视频 RTSP Win',
                                downloadurl:"https://cdn.thingjs.com/LiveServer/LiveServerRTSP-20220415-Win.zip",
                                icon:'../../static/img/unsplash-photo-4.png',
                                imgurl:"../../static/img/tool/icon_3d-max.gif",
                                btnfont:"下载",
                                info:[
                                    {name:"文件大小",content:"41.7MB"},
                                    {name:"更新时间",content:"2022/04/15"},
                                    // {name:"MD5",content:"23662A25B8F6416BF08446DDF92A490E"},
                                    {name:"介绍",content:"森视频提供了RTSP视频流转H5视频流功能，支持海康、大华等各类厂家监控摄像头的RTSP视频流接入；单服务器授权，永久有效；提供安装手册及远程技术支持。"},
                                ]
                            }
                        ],
                        namecn: "视频流服务器",
                        descr:'ThingJS LiveServer（ThingJS官方视频流服务器）提供了GB28181视频流转H5视频流功能，支持海康、大华等各类厂家的标准监控摄像头的接入；单服务器授权，永久有效；提供安装手册及远程技术支持；',
                        icon:'../../static/img/unsplash-photo-4.png',
                        imgurl:"../../static/img/tool/icon_3d-max.gif",
                        eachicon:'../../static/img/eachicon4.png',
                        btnfont:"下载",
                        downloadurl:"http://pan.baidu.com/s/1cmeIp4",
                        link:[
                            // {name:"使用教程",url:"http://3dmomoda.oss-cn-beijing.aliyuncs.com/common/%E6%A8%A1%E6%A8%A1%E6%90%AD%E6%8F%92%E4%BB%B6%E4%BD%BF%E7%94%A8%E6%95%99%E7%A8%8B_%E8%AF%A6%E7%BB%862019.12.17.pdf"}
                        ],
                        info:[

                                {name:"版本号",content:"2.4"},
                                {name:"文件大小",content:"28.3MB"},
                                {name:"更新时间",content:"2018/11/23"},
                                {name:"MD5",content:"23662A25B8F6416BF08446DDF92A490E"},
                                {name:"介绍",content:"ThingJS LiveServer（ThingJS官方视频流服务器）提供了GB28181视频流转H5视频流功能，支持海康、大华等各类厂家的标准监控摄像头的接入；单服务器授权，永久有效；提供安装手册及远程技术支持；"},
                           ]


                    },


                    // 文档
                    {
                        type:2,
                        typename:"文档",
                        name:"森园区-用户手册",
                        descr:'了解森园区客户端的功能特性和使用方法，快速搭建您的园区。',
                        icon:require('../../static/img/icons/CampusBuilder.png'),
                        imgurl:"../../static/img/tool/icon_gjjc.gif",
                        btnfont:"查看",
                        downloadurl:"https://cdn.thingjs.com/doc/CampusBuilder%E7%94%A8%E6%88%B7%E6%89%8B%E5%86%8C%20Rev.1.1.pdf",
                        link:[],
                        info:[
                             {name:"版本号",content:"1.1"},
                             {name:"文件大小",content:"6.11MB"},
                             {name:"更新时间",content:"2021/6/8"},
                            {name:"介绍",content:"了解CampusBuilder的功能特性和使用方法，快速搭建您的园区。"},
                        ],
                        children:[
                            {
                                type:2,
                                typename:"文档",
                                name:"(客户端版)",
                            },
                        ]
                    },
                    {
                        type:2,
                        typename:"文档",
                        name:"森城市-用户手册",
                        descr:'帮助您快速掌握城市级 3D 场景的搭建方法。',
                        icon:require('../../static/img/icons/CityBuilder.png'),
                        detailname:"森城市-用户手册",
                        imgurl:"../../static/img/tool/icon_APIsc.gif",
                        btnfont:"查看",
                        downloadurl:"https://cdn.thingjs.com/doc/CityBuilder%E7%94%A8%E6%88%B7%E6%89%8B%E5%86%8C%20Rev.1.1.pdf",
                        link:[],
                        info:[
                             {name:"版本号",content:"1.1"},
                             {name:"文件大小",content:"1.58MB"},
                             {name:"更新时间",content:"2021/6/2"},
                             {name:"介绍",content:"帮助您快速掌握城市级 3D 场景的搭建方法。"},
                        ],
                        children:[
                            {
                                type:2,
                                typename:"文档",
                                name:"(Pro版)",
                                descr:'应用效果模板、设置属性、切换灯光方案，使场景更炫酷。',
                                icon:require('../../static/img/icons/CityBuilderPro.png'),
                                imgurl:"../../static/img/tool/icon_APIsc.gif",
                                btnfont:"查看",
                                 detailname:"CityBuilderPro 用户手册",
                                downloadurl:"https://cdn.thingjs.com/doc/BuilderPro%E7%94%A8%E6%88%B7%E6%89%8B%E5%86%8C%20Rev.%201.1.pdf",
                                link:[],
                                info:[
                                {name:"版本号",content:"1.1"},
                                {name:"文件大小",content:"1.15MB"},
                                {name:"更新时间",content:"2021/6/23"},
                                {name:"介绍",content:"应用效果模板、设置属性、切换灯光方案，使场景更炫酷。"},
                                ]
                            },
                        ]
                    },
                    {
                        type:2,
                        typename:"文档",
                        name:"森Max三维模型-用户手册",
                        descr:'学习ThingJS模型制作标准及3ds Max模型上传插件的使用方法，来制作模型。',
                        icon:require('../../static/img/icons/guide.png'),
                        imgurl:"../../static/img/tool/icon_gjjc.gif",
                        btnfont:"查看",
                        downloadurl:"https://cdn.thingjs.com/doc/ThingJS%20%E5%B9%B3%E5%8F%B0%E4%B8%89%E7%BB%B4%E6%A8%A1%E5%9E%8B%E5%88%B6%E4%BD%9C%E6%8C%87%E5%8D%97%20Rev.%201.0.pdf",
                        link:[],
                        info:[
                             {name:"版本号",content:"1.0"},
                             {name:"文件大小",content:"956KB"},
                             {name:"更新时间",content:"2021/6/18"},
                            {name:"介绍",content:"学习ThingJS模型制作标准及模型上传插件的使用方法，来制作模型。"},
                        ]
                    },
                    {
                        type:2,
                        typename:"文档",
                        name:"森BIM插件-用户手册",
                        descr:'学习使用此插件，将BIM相关的.rvt文件转换成TJS场景文件格式。',
                        icon:require('../../static/img/icons/whitepaper.png'),
                        imgurl:"../../static/img/tool/icon_gjjc.gif",
                        btnfont:"查看",
                        downloadurl:"https://cdn.thingjs.com/doc/%E6%A3%AEBIM%E6%8F%92%E4%BB%B6%20for%20Revit%E4%BD%BF%E7%94%A8%E6%96%87%E6%A1%A3%20Rev1.1.pdf",
                        link:[],
                        info:[
                             {name:"版本号",content:"1.1"},
                             {name:"文件大小",content:"2.20MB"},
                             {name:"更新时间",content:"2022/05/16"},
                            {name:"介绍",content:"学习使用此插件，将BIM相关的.rvt文件转换成TJS场景文件格式。"},
                        ]
                    },
                    {
                        type:2,
                        typename:"文档",
                        name:"离线开发坐席版-用户手册",
                        descr:'使用ThingJS离线开发包，确保整个项目开发过程的保密性。',
                        icon:require('../../static/img/icons/offlinepackage.png'),
                        imgurl:"../../static/img/tool/icon_APIsc.gif",
                        btnfont:"查看",
                        downloadurl:"https://cdn.thingjs.com/doc/ThingJS%E7%A6%BB%E7%BA%BF%E5%BC%80%E5%8F%91%20SDK%20%E8%AF%B4%E6%98%8E%E4%B9%A6%20Rev.%201.6.0.pdf",
                        link:[],
                        info:[
                             {name:"版本号",content:"1.6"},
                             {name:"文件大小",content:"1.25MB"},
                             {name:"更新时间",content:"2021/12/3"},
                            {name:"介绍",content:"使用ThingJS离线开发包，确保整个项目开发过程的保密性。"},
                        ]
                    },
                    {
                        type:2,
                        typename:"文档",
                        name:"离线开发网络版-用户手册",
                        descr:'在局域网中多名开发人员共同开发，不限人数，不限项目。',
                        icon:require('../../static/img/icons/specification.png'),
                        imgurl:"../../static/img/tool/icon_gjjc.gif",
                        btnfont:"查看",
                        downloadurl:"https://cdn.thingjs.com/doc/ThingJS%E7%A6%BB%E7%BA%BF%E5%BC%80%E5%8F%91%E7%BD%91%E7%BB%9C%E7%89%88-%E7%94%A8%E6%88%B7%E6%89%8B%E5%86%8C%20Rev.1.2.5.pdf",
                        link:[],
                        info:[
                             {name:"版本号",content:"1.0"},
                          {name:"文件大小",content:"1.62MB"},
                             {name:"更新时间",content:"2018/09/15"},
                            {name:"介绍",content:"在局域网中多名开发人员共同开发，不限人数，不限项目。"},
                        ]
                    },
                    {
                        type:2,
                        typename:"文档",
                        name:"项目离线部署包-用户手册",
                        descr:'将ThingJS项目离线部署到实际应用场景中。',
                        icon:require('../../static/img/icons/offline.png'),
                        imgurl:"../../static/img/tool/icon_APIsc.gif",
                        btnfont:"查看",
                        downloadurl:"https://cdn.thingjs.com/doc/ThingJS%E9%A1%B9%E7%9B%AE%E7%A6%BB%E7%BA%BF%E9%83%A8%E7%BD%B2%E5%8C%85-%E7%94%A8%E6%88%B7%E6%89%8B%E5%86%8C%20Rev.3.2.5.pdf",
                        link:[],
                        info:[
                             {name:"版本号",content:"3.2.5"},
                             {name:"文件大小",content:"3.44MB"},
                             {name:"更新时间",content:"2022/06/20"},
                            {name:"介绍",content:"将ThingJS项目离线部署到实际应用场景中。"},
                        ]
                    },
                    {
                        type:2,
                        typename:"文档",
                        name:"森视频 部署包-用户手册",
                        descr:'支持两种协议下的视频流转换功能，使视频在浏览器中顺利播放。',
                        icon:require('../../static/img/icons/live-server.png'),
                        imgurl:"../../static/img/tool/icon_gjjc.gif",
                        btnfont:"查看",
                        downloadurl:"https://cdn.thingjs.com/doc/LiveServer%20GB_T28181%20%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6%20Rev.2.2.pdf",
                        link:[],
                        info:[
                             {name:"版本号",content:"2.2"},
                             {name:"文件大小",content:"2.88MB"},
                             {name:"更新时间",content:"2021/12/27"},
                            {name:"介绍",content:"支持两种协议下的视频流转换功能，使视频在浏览器中顺利播放。"},
                        ]
                    },
                    //其它
                    {
                        type:3,
                        typename:"文档",
                        name:"离线部署包-补丁",
                        descr:' 用于项目离线部署包中需添加“更新与迁移”页签情况。',
                        icon:require('../../static/img/icons/offline.png'),
                        imgurl:"../../static/img/tool/icon_gjjc.gif",
                        btnfont:"下载",
                        downloadurl:"https://cdn.thingjs.com/tool/%E7%A6%BB%E7%BA%BF%E9%83%A8%E7%BD%B2%E5%8C%85%E8%A1%A5%E4%B8%81.zip",
                        link:[],
                        info:[
                             {name:"版本号",content:"3.0"},
                             {name:"文件大小",content:"957KB"},
                             {name:"更新时间",content:"2021/08/02"},
                             {name:"介绍",content:" 某些特定的情况下，离线部署授权页面会缺少“更新与迁移”页签，导致无法进行“更新与迁移授权”的操作，通过更新该补丁文件，即可为离线部署授权页面创建“更新与迁移”页签。"},
                        ]
                    }

                ],
                screenWidth: document.body.clientWidth,
                isNormal:true
            }
        },
        methods:{
            openLog: function(title,fileName){
                layer.open({
                type: 2,
                move: false,
                title: [title, 'font-size: 18px; height: 50px; line-height: 50px; font-weight: 600; padding-left: 30px;'],
                closeBtn: 1,
                shade: 0,
                // scrollbar: false,
                area: ['630px', '600px'],
                resize: false,
                content: ['https://www.thingjs.com/guide/html/agreements/'+ fileName +'.html'],
                skin: 'pageClass',
                success: function () {

                },
                cancel: function () {
                    // 右上角关闭事件的逻辑
                }
            });
            },
            download:function(url){
                window.open(url);
            },
            toolDetail:function(toolInfo){
                if($.cookie('openid')){
                    this.toolDetailInfo =  JSON.parse(JSON.stringify(toolInfo));
                    this.showToolPage = true;
                }else{
                    logoinForStore();
                }
            },
            checkCampany:function(toolInfo,e,type){
                var e=e||window.event;
                e.stopPropagation();
                window.AnalysysAgent && window.AnalysysAgent.track('ResourcesCenter_Click', {
                    resources: '下载',
                    projectName: toolInfo.name
                })
                var _this = this;
                if($.cookie('openid')){
                    this.$reqs.get("/user/User_info?token="+$.cookie('token')).then(function(result) {
                        var openPage = '';
                        var infos =  result.data;
                        if(!infos.phoneVerify) openPage = 'phone';
                        if(!infos.office || !infos.company || !infos.namebyCam) openPage = openPage?openPage+'.info':'info';
                        if(openPage){//缺
                            // var msg = {title:'查看模型',subject:'viewModel',toolInfo:toolInfo};
                            var msg = {title:'下载',subject:'downDocum',toolInfo:infos};
                            bus.$emit('view',msg);
                            // _this.showPanel();
                            // infos.type = 'downDocum';
                            // infos.msg = {title:'下载',pages:openPage,toolInfo:toolInfo}
                            // bus.$emit("openCampanyPanel",{infos:infos});
                        }else{//不缺
                            if(type) {
                                window.open(toolInfo.downloadurl)
                                return;
                            }
                            _this.toolDetail(toolInfo);
                        }
                    }).catch(function(error) {
                        console.log(error);
                    });
                }else{
                    logoinForStore();
                }
            },
            showTooltip: function(event) {
				var content = $(event.target).data("content");
				var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
				$(event.target).append(tipEle);
			},
			cancelTooltip: function(event) {
				$("div").remove(".tooltips");
            },
			formatNumber: function(number) {
				if(number < 1000) {
					return number;
				} else {
					return(number / 1000).toFixed(1) + "k";
				}
            },
            screenTool:function(id){
                 var tmptoolList = [];
                for(var i = 0; i < this.allToolList.length; i++){
                    if(id == "software"){
                        if(this.allToolList[i].type == 1){
                            tmptoolList.push(this.allToolList[i]);
                        }
                    }else if(id == "file"){
                        if(this.allToolList[i].type == 2){
                            tmptoolList.push(this.allToolList[i]);
                        }
                    }else if(id == 1){
                        tmptoolList.push(this.allToolList[i]);
                    }
                }
                this.toolList = JSON.parse(JSON.stringify(tmptoolList));
                bus.$emit('changeListCount',this.toolList.length);
            },
            initToolList:function(){
                 this.toolList = JSON.parse(JSON.stringify(this.allToolList));
                 bus.$emit('changeListCount',this.toolList.length);
            },
            queryToolList:function(){
                if(this.queryData.type==""){
                    this.toolList = JSON.parse(JSON.stringify(this.allToolList));
                    bus.$emit('changeListCount',this.toolList.length);
                }
            },
            downLoadModels:function(){
                this.$reqs.get("/down/downLoadModels").then(function(result) {
                    console.log('downLoadModels success');
                }).catch(function(error) {
                    console.log('downLoadModels error'+error);
                });
            },
            showPanel:function(){
                if($.cookie('openid')){
                    this.panelShow = true;
                }
            },
            hidePanel:function(success) {
                var _this = this;
                this.panelShow = false;
                window.parent.postMessage('close','*');
            },
            // load(){
            //     this.allToolList=GETSTORETOOLS
            // }
        },
        beforeDestroy () {
            bus.$off("toolListChangeEvent");
            bus.$off("changeToolList");
        },
        created () {
            var _this = this;
            if(location.pathname == '/zeroCode/tools') {
                this.iszero = true;
                $.ajax({
                    url: 'https://www.thingjs.com/static/toolConfig/toolConfig.json',
                    type:'get',
                    dataType:'json',
                    success: function (data) {
                        _this.newToolList.push(data.storeZerocode)
                        _this.allToolList = _this.newToolList
                    },
                });
            }else {
                // if (!document.getElementById('toolConfig')) {  //避免多次引入
                    $.ajax({
                        url: 'https://www.thingjs.com/static/toolConfig/toolConfig.json',
                        type:'get',
                        dataType:'json',
                        success: function (data) {
                            _this.newToolList.push(data.storeoffBDPdf)
                            
                            _this.newToolList.push(data.campusBuilder)
                            _this.newToolList.push(data.storeCityPdf)
                            _this.newToolList.push(data.plugin)
                            _this.newToolList.push(data.bimRevit)
                            _this.newToolList.push(data.offlineSDK)
                            _this.newToolList.push(data.offline)
                            _this.newToolList.push(data.offlineDeployment)
                            _this.newToolList.push(data.liveServerGB)
                            
                            _this.newToolList.push(data.campClient)
                            _this.newToolList.push(data.threeMax)
                            _this.newToolList.push(data.revit)
                            _this.newToolList.push(data.liveSever)
                            _this.newToolList.push(data.downloadOfflineSDK)
                            _this.newToolList.push(data.storeoffline)
                            _this.newToolList.push(data.downloadOfflineDeployment)
                            
                            _this.newToolList.push(data.storeZerocode)
                            
                            _this.newToolList.push(data.downloadOfflineWeb)

                            _this.allToolList = _this.newToolList
                        },
                    });
                // }
            }
        },
        mounted(){
            var _this = this;
            // if (!document.getElementById('toolConfig')) {  //避免多次引入
            //     $.ajax({
            //         url: 'http://127.0.0.1/static/toolConfig/toolConfig.json',
            //         type:'get',
            //         dataType:'json',
            //         success: function (data) {
            //             _this.allToolList = data
            //         },
            //     });
                // const script = document.createElement('script');
                // script.type = 'text/javascript';
                // script.src = 'http://127.0.0.1/static/toolConfig/toolConfig.json';
                // script.id = 'toolConfig';
                // script.addEventListener('load',this.load)
                // document.body.appendChild(script);
            // }
            this.initToolList();
            bus.$on("toolListChangeEvent", (id) => {
                this.screenTool(id);
            });
            bus.$on("changeToolList", (data) => {
                this.queryData = JSON.parse(JSON.stringify(data));
                this.queryToolList();
            });
            bus.$on("downInfo", (data) => {
                _this.step = data.step;
                _this.toolDetail(data.infos);
            });
            const that = this
            if(document.body.clientWidth < 1903) {
                that.isNormal=false;
            }else {
                that.isNormal=true;
            }
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.screenWidth = window.screenWidth
                })()
            }
        },
        watch:{
            screenWidth(val){
                if(!this.timer){
                this.screenWidth = val
                this.timer = true
                let that = this
                setTimeout(function(){
                    if(that.screenWidth < 1903) {
                        that.isNormal=false;
                    }else {
                        that.isNormal=true;
                    }
                    that.timer = false
            },400)
        }
    }
}
    }
</script>
<style>
@import "../assets/css/tools_new.css";
.newButton {
    background-color: #ff8000;
    padding: 0px 6px;
    border-radius: 20px;
    min-height: 1.5rem;
}
/* .splCard {
    justify-content: space-between !important;
} */
.moreText {
    padding: 0px 4px;
    margin-left: 0.35rem;
    height: max-content;
    min-height: 1.5rem;
}
.rightStyle {
    margin-right: 0rem !important;
}
.rightStyleNew {
    margin-right: 1rem !important;
}
.modelList_box .tools .mt-auto {
    margin: 1rem 0.5rem 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/tool.vue